import styled from 'styled-components'
import { Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${Spacing.L};
  gap: ${Spacing['2XS']};
  ${Media.Phone`
    margin-top: ${Spacing.M};
  `}
`
